import { memo, useMemo } from 'react';
import IntroPromoLabel from '../../IntroPromoLabel/IntroPromoLabel';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { AuthNavigatorParamsList } from '../../../navigators/AuthNavigator/AuthNavigator.types';
import { Trans } from '@bonanza-social/i18n';

function IntroMainContentNewPlayer() {
  const navigation =
    useNavigation<StackNavigationProp<AuthNavigatorParamsList>>();

  const logInComponent = useMemo(
    () => ({
      textLink: (
        <Text
          variant="link-small"
          onPress={() => navigation.navigate('LoginScreen')}
        />
      ),
    }),
    [],
  );
  return (
    <Box gap="space-400" paddingBottom="space-500">
      <IntroPromoLabel />
      <Box gap="space-300">
        <Button
          locKey="join"
          locNS="auth"
          size="large"
          onPress={() => navigation.navigate('RegistrationScreen')}
        />
        <Text
          variant="link-small"
          color="darkSurfacePrimary"
          onPress={() => navigation.navigate('LoginScreen')}
        />
        <Text
          variant="body-s"
          color="darkSurfacePrimary"
          alignSelf="center"
          marginTop="-space-300"
        >
          <Trans
            i18nKey="introScreenLoginLinkText"
            ns="auth"
            components={logInComponent}
          />
        </Text>
      </Box>
    </Box>
  );
}
export default memo(IntroMainContentNewPlayer);
